import { retrieveSchema as retrieveSchemaUtil } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv6';
import { memoize } from 'lodash';

const resolver = (schema, formData) => JSON.stringify({ schema, formData });

function retrieveSchema(schema, formData) {
  if (!schema || typeof schema !== 'object') return null;
  let defaultedFormData = formData;
  if (!formData || typeof formData !== 'object') {
    defaultedFormData = {};
  }

  const rootSchema = schema;
  return retrieveSchemaUtil(validator, schema, rootSchema, defaultedFormData);
}
const retrieveSchemaMemo = memoize(retrieveSchema, resolver);

export { validator, retrieveSchemaMemo as retrieveSchema };
